const profileNL = {
    "edit": {
        "title": "Bewerk je profiel",
        "form": {
            "label": {
                "profileImage": "Profielfoto",
                "streetAndNumber": "Mijn Straat en huisnummer",
                "postalCode": "Postcode",
                "city": "Stad",
                "country": "Land",
                "vatNumber": "Btw-nummer",
                "nationalTaxNumber": "Nationaal belastingnummer",
                "businessRegistrationNumber": "Bedrijfsregistratienummer",
                "vatStatus": "Btw-status",
                "businessType": "Bedrijfstype",
                "vatExemptDocument": "Btw-vrijstellingsdocument",
                "businessCertificate": "Bedrijfscertificaat",
                "preferredPaymentMethod": "Voorkeursbetaalmethode",
                "paypalEmail": "Paypal e-mail",
                "accountHolderName": "Naam rekeninghouder",
                "bankName": "Banknaam",
                "bankAddress": "Bankadres",
                "iban": "IBAN"
            },
            "option": {
                "preferedMethod": {
                    "paypal": "Paypal",
                    "bankAccount": "Bankrekening"
                }
            },
            "help_text": {
                "profileImage": "Upload JPG-formaat, resolutie alleen 300x300 px, maximale grootte 300 KB.",
                "iban": "Vergeet niet het voorvoegsel van uw land, bijvoorbeeld DE, FR, ES"
            },
            "button": {
                "submit": "Verzenden"
            }
        },
        "message": {
            "success": "Je profiel is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "header": "Weet je zeker dat je je profiel wilt wijzigen?",
            "body": "Hierbij garandeer je dat alle verstrekte gegevens waarheidsgetrouw zijn. Je bent als enige en wettelijk verantwoordelijk voor de verstrekte gegevens en voor de waarheidsgetrouwheid van dergelijke informatie.",
            "button": {
                "cancel": "Annuleren",
                "confirm": "Bevestigen"
            }
        }
    },
    "set_new_password": {
        "title": "Nieuw wachtwoord instellen",
        "form": {
            "label": {
                "currentPassword": "Huidig wachtwoord",
                "newPassword": "Nieuw wachtwoord",
                "repeatNewPassword": "Herhaal nieuw wachtwoord"
            },
            "button": {
                "submit": "Verzenden"
            },
            "validation": {
                "oldPasswordRequired": "Je oude wachtwoord is vereist",
                "newPasswordMin": "Je wachtwoord moet minimaal 10 tekens lang zijn",
                "newPasswordRequired": "Nieuw wachtwoord is vereist",
                "passwordsMustMatch": "Nieuw wachtwoord moet overeenkomen"
            }
        },
        "message": {
            "success": "Je wachtwoord is gewijzigd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "header": "Weet je zeker dat je je wachtwoord wilt wijzigen?",
            "body": "Bevestig alstublieft"
        }
    },
    "panel": {
        "label": {
            "emailAddress": "E-mailadres",
            "paypalEmailAddress": "Paypal e-mailadres",
            "phone": "Telefoon",
            "streetAndHouseNumber": "Straat en huisnummer",
            "postalCode": "Postcode",
            "city": "Stad",
            "country": "Land",
            "paymentMethod": "Betaalmethode",
            "accountNumberHolder": "Rekeninghouder",
            "bankName": "Banknaam",
            "iban": "IBAN",
            "bic": "BIC",
            "bankAddress": "Bankadres",
            "paypal": "Paypal",
            "bankAccount": "Bankrekening"
        }
    },
    "payment_method": {
        "title": "Betaalmethode",
        "label": {
            "card_number": "Kaartnummer",
            "card_expiry": "Vervaldatum",
            "default_method": "Standaard",
            "manage_method": "Beheren",
            "add_method": "Toevoegen"
        }
    },
    "withholding_tax": {
        "title": "Bronbelasting",
        "form": {
            "label": {
                "taxPercentage": "Belastingpercentage",
                "whtStatus": "WHT-status",
                "whtLicense": "WHT-licentie"
            },
            "help_text": {
                "uploadDocument": "Upload alstublieft uw bronbelastingdocument."
            },
            "button": {
                "submit": "Verzenden",
                "removeFile": "Verwijderen?"
            },
            "message": {
                "whtStatusText": "Volgens artikel 31 van de Kroatische winstbelastingwet wordt een bronbelasting van 15-25% toegepast op niet-ingezetenen. Als u echter in een land woont dat een overeenkomst ter voorkoming van dubbele belasting met Kroatië heeft, kunt u in aanmerking komen voor een verlaagd belastingtarief. U kunt controleren of uw land is opgenomen op <1><strong>deze link</strong></1>.",
                "whtApplyRateText": "Om in aanmerking te komen voor het verlaagde tarief, klikt u op <1><strong>dit document</strong></1>. Download, vul in en dien het formulier in om te profiteren van het tarief dat in de overeenkomst is gespecificeerd, indien van toepassing."
            }
        },
        "message": {
            "success": "WHT-licentie succesvol ingediend. Het zal door ons team worden verwerkt.",
            "error": "Er is een fout opgetreden bij het bijwerken. Probeer het opnieuw."
        }
    }
};

export default profileNL;